import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home/Home'
import TakeQuiz from './components/TakeQuiz/TakeQuiz'
import LiveQuiz from './components/Live/Question'
import CreateLive from './components/Admin/CreateLive'
import ReplayQuiz from './components/Replay/Quiz'
import QuizHome from './components/Quiz/Quiz'
import CreateShow from './components/Admin/CreateEntity/CreateShow'
import CreateQuiz from './components/Admin/CreateQuiz/CreateQuiz'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/addentity',
      name: 'addentity',
      component: CreateShow
    },
    {
      path: '/admin/createq/:entity',
      name: 'CreateQuiz',
      component: CreateQuiz
    },
    // {
    //   path: '/quiz',
    //   name: 'quiz',
    //   component: TakeQuiz
    // },
    {
      path: '/quiz/:quizid',
      name: 'quiz',
      component: QuizHome,
      alias: "/fromreplay/:quizid"

    },
    {
      path: '/live/:liveid/:answer?',
      name: 'live',
      component: LiveQuiz
    },
    {
      path: '/replay/:quiz/:question',
      name: 'replay',
      component: ReplayQuiz
    },
    
    // { 
    //   path: '/livesubmitted/:liveid',
    //   name: 'livesubmitted',
    //   component: LiveSubmitted
    // },
    {
      path:'/admin/createlive',
      name:'createlive',
      component: CreateLive
    }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
